export default __webpack_public_path__ + "static/media/3.10170ad7.jpg";